import React from 'react';
import Radium from 'radium';
import { Icon, Loader } from 'semantic-ui-react';

const styles = {
	button: {
		backgroundColor: '#00c7b1',
		height: 40,
		width: 40,
		color: '#fff',
		fontFamily: 'Lato',
		textTransform: 'uppercase',
		padding: 0,
		fontSize: '0.8em',
		lineHeight: '40px',
		fontWeight: 600,
		cursor: 'pointer',
		outline: 'none',
		border: 0,
		borderRadius: '4px',
		boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
		transition:
			'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
		':hover': {
			backgroundColor: '#00bda8',
			boxShadow:
				'0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
			color: '#f5f5f5',
		},
		':active': {
			backgroundColor: '#00ae99',
			color: '#e6e6e6',
		},
		':disabled': {
			backgroundColor: '#D3D3D3',
		},
	},
	icon: {
		margin: 0,
		color: '#fff',
	},
};

const IconButton = ({ onClick, isLoading, iconName, disabled, style }) => {
	return (
		<button
			style={{...styles.button, ...style}}
			onClick={(e) => {
				if (e !== undefined) e.preventDefault();
				onClick();
			}}
			disabled={disabled}
		>
			{isLoading ? (
				<Loader active inline size='small' />
			) : (
				<Icon name={iconName} size='large' style={styles.icon} />
			)}
		</button>
	);
};

export default Radium(IconButton);
